import MainRoutes from "../src/Components/route";

function App() {
  return (
    <>
      <MainRoutes />
    </>
  );
}

export default App;
